import dayjs from "dayjs";

/**
 * Formats a date into MM/DD/YYYY for display.
 * @param {string|Date} inputDate - Input date (MM/DD/YYYY, ISO, or Date object)
 * @returns {string} Date in MM/DD/YYYY format or "-" when invalid.
 */
export const GetDateInMMDDYYYY = (inputDate) => {
  if (!inputDate) {
    return "-";
  }

  try {
    const normalizedInput = String(inputDate).trim();
    if (
      normalizedInput === "0001-01-01T00:00:00Z" ||
      normalizedInput === "0001-01-01T00:00:00.000Z" ||
      normalizedInput.startsWith("0001-01-01")
    ) {
      return "-";
    }

    // Strip the Z suffix before parsing so dayjs treats the value as local
    // time rather than UTC — prevents a day-shift in US timezones when the
    // stored string is "YYYY-MM-DDTHH:mm:ssZ" (date-only, labeled as UTC).
    const normalized = normalizedInput.replace(/Z$/, "");
    const parsedDate = dayjs(normalized);
    if (!parsedDate.isValid()) {
      return "-";
    }

    return parsedDate.format("MM/DD/YYYY");
  } catch (error) {
    console.error("Error formatting date:", error);
    return "-";
  }
};
